<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-md-12">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Cadastro de Vendedor</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="/cadastros/vendedores">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Preencha os dados do vendedor para iniciar suas operações
            </p>
          </div>
        </div>
      </div>
    </div>

    @if (isLoading) {
    <div class="row">
      <div class="col-12 mb-4">
        <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>

        <div class="row">
          <div class="col-12 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-6 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-6 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
        </div>
      </div>

      <div class="col-12 mb-4">
        <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>
        <div class="row">
          <div class="col-4 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
          <div class="col-8 mb-3">
            <app-loading-box [height]="'56'"></app-loading-box>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <form [formGroup]="form" (ngSubmit)="salvar()">
      <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

      <!-- Seção 1: Informações Básicas -->
      <div class="section-container" id="info-basica">
        <div class="section-title">
          <mat-icon>person</mat-icon>
          <span>Informações Básicas</span>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="d-block mb-2 small">Tipo de Pessoa</label>
            <mat-radio-group formControlName="idTipoPessoa" class="radio-group">
              @for (tipo of listaTipoPessoa; track tipo.id) {
              <mat-radio-button [value]="tipo.id">{{ tipo.descricao }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome Completo</mat-label>
              <input matInput formControlName="nome" required />
              @if (form.get('nome')?.hasError('required')) {
              <mat-error>Obrigatório</mat-error>
              }
              <mat-hint>Insira o nome completo do vendedor</mat-hint>
            </mat-form-field>
          </div>

          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CPF</mat-label>
              <input matInput formControlName="cpf" [mask]="masks.cpf" />
              @if (form.get('cpf')?.hasError('required')) {
              <mat-error>CPF é obrigatório para pessoa física</mat-error>
              } @else if (form.get('cpf')?.invalid) {
              <mat-error>Informe um CPF válido</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CNPJ</mat-label>
              <input matInput formControlName="cnpj" [mask]="masks.cnpj"
                (blur)="consultarCnpj(form.get('cnpj')?.value)" />
              @if (isLoadingCnpj) {
              <mat-spinner class="inline-loading" matSuffix [diameter]="20"></mat-spinner>
              } @else {
              <mat-icon matSuffix (click)="consultarCnpj(form.get('cnpj')?.value)"
                style="cursor: pointer">search</mat-icon>
              }
              @if (form.get('cnpj')?.hasError('required')) {
              <mat-error>CNPJ é obrigatório para pessoa jurídica</mat-error>
              } @else if (form.get('cnpj')?.invalid) {
              <mat-error>Informe um CNPJ válido</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Documento Estrangeiro</mat-label>
              <input matInput formControlName="documentoEstrangeiro" />
            </mat-form-field>
          </div>

          <div class="col-6">
            <app-select-pesquisavel [control]="idPais" [offlineList]="listaPaises" label="País" idField="id"
              nameField="descricao">
            </app-select-pesquisavel>
          </div>

          <div class="col-6">
            <app-select-pesquisavel [control]="idSituacaoVendedor" [offlineList]="listaSituacao" label="Situação"
              idField="id" nameField="descricao" [isOptional]="false">
            </app-select-pesquisavel>
          </div>

          <div class="col-6">
            <app-select-pesquisavel [control]="idUsuario" [offlineList]="listaUsuarios" label="Usuário do Sistema"
              idField="idUsuario" nameField="nomeUsuario" [isOptional]="true">
            </app-select-pesquisavel>
          </div>
        </div>
      </div>

      <!-- Seção 2: Endereço e Contato -->
      <div class="section-container" id="endereco">
        <div class="section-title">
          <mat-icon>location_on</mat-icon>
          <span>Endereço e Contato</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CEP</mat-label>
              <input matInput formControlName="cep" (blur)="buscarCep()" [mask]="masks.cep" />
              @if (isLoadingCep) {
              <mat-spinner class="inline-loading" matSuffix [diameter]="20"></mat-spinner>
              } @else {
              <mat-icon matSuffix (click)="buscarCep()" style="cursor: pointer">search</mat-icon>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Endereço</mat-label>
              <input matInput formControlName="logradouro" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número</mat-label>
              <input matInput formControlName="numero" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Complemento</mat-label>
              <input matInput formControlName="complemento" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Bairro</mat-label>
              <input matInput formControlName="bairro" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <app-select-pesquisavel [control]="idUnidadeFederativa" [offlineList]="listaUf" label="UF" idField="id"
              nameField="descricao" (selectionChange)="changeUnidadeFederativa($event)">
            </app-select-pesquisavel>
          </div>
          <div class="col-12 col-md-5">
            <app-select-pesquisavel [control]="idMunicipio" [apiUrl]="urlMunicipio" label="Município"
              idField="idMunicipio" nameField="nome" [preloadedOptions]="preloadedCity"
              (selectionChange)="changeCidade($event)">
            </app-select-pesquisavel>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email</mat-label>
              <mat-icon matPrefix class="me-2 text-secondary">email</mat-icon>
              <input matInput formControlName="email" />
              @if (form.get('email')?.hasError('required')) {
              <mat-error>Informe o e-mail</mat-error>
              } @else if (form.get('email')?.hasError('email')) {
              <mat-error>E-mail inválido</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Telefone</mat-label>
              <input matInput formControlName="telefone" [mask]="masks.phone" />
              @if (form.get('telefone')?.hasError('required')) {
              <mat-error>Informe o telefone</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>E-mail para comunicações</mat-label>
              <mat-icon matPrefix class="me-2 text-secondary">mail_outline</mat-icon>
              <input matInput formControlName="emailComunicacao" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Seção 3: Comissão -->
      <div class="section-container" id="comissao">
        <div class="section-title">
          <mat-icon>percent</mat-icon>
          <span>Comissão</span>
        </div>

        <div class="row">
          <div class="col-12">
            <app-select-pesquisavel [control]="idRegraLiberacaoComissao" [offlineList]="listaRegrasComissao"
              label="Regras para liberação de comissões" idField="id" nameField="descricao" [isOptional]="!isObrigatorio('id_regra_liberacao_comissao')">
            </app-select-pesquisavel>
          </div>

          <div class="col-12">
            <mat-checkbox [checked]="form.get('idTipoComissao')?.value === TipoComissaoEnum.Fixa"
              (change)="setTipoComissao(TipoComissaoEnum.Fixa, $event.checked)">Percentual de comissão
              fixa</mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox [checked]="form.get('idTipoComissao')?.value === TipoComissaoEnum.Desconto"
              (change)="setTipoComissao(TipoComissaoEnum.Desconto, $event.checked)">Comissão com percentual conforme
              descontos</mat-checkbox>
          </div>
          @if (form.get('idTipoComissao')?.touched && form.get('idTipoComissao')?.hasError('required')) {
          <div class="col-12">
            <mat-error class="comissao-erro" tabindex="-1">Selecione a modalidade e informe um percentual maior que zero ou cadastre ao menos uma faixa de comissão</mat-error>
          </div>
          }

          @if (!showDiscountGrid) {
          <div class="col-4">
            <mat-form-field appearance="outline">
              <mat-label>Comissão (%)</mat-label>
              <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                formControlName="percentualComissaoFixa" />
              @if (form.get('percentualComissaoFixa')?.hasError('min')) {
              <mat-error> Não pode ser menor que zero </mat-error>
              } @else if (form.get('percentualComissaoFixa')?.hasError('valorMaiorQueZero')) {
              <mat-error>Informe um percentual maior que zero</mat-error>
              }
            </mat-form-field>
          </div>
          }
        </div>

        <div class="row">
          @if (showDiscountGrid) {
          <div class="col-12 discount-grid" formArrayName="faixasComissao">
            <!-- <div class="add-button-container d-lg-none">
                <button
                  type="button"
                  mat-stroked-button
                  color="warn"
                  class="btn-rounded-add"
                  (click)="addDescontoRow()">
                  <mat-icon>add</mat-icon> Adicionar Faixa
                </button>
              </div> -->

            <div class="d-flex justify-content-between align-items-center mb-2 mt-4">
              <p>Faixas de Comissão</p>
              <button type="button" mat-button (click)="addDescontoRow()" matTooltip="Adicionar nova faixa">
                <mat-icon>add</mat-icon> Adicionar
              </button>
            </div>

            @for (item of discountsArray.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="discount-row-wrapper">
              <div class="row w-100 g-2 align-items-end m-0">
                <div class="col-5 col-lg-5">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic"
                    class="w-100 no-bottom-space compact-input">
                    <mat-label>Desconto de até (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                      formControlName="percentualDesconto" placeholder="0" />
                    @if (discountsArray.controls[i].get('percentualDesconto')?.hasError('min')) {
                    <mat-error> Não pode ser menor que zero </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-5 col-lg-5">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic"
                    class="w-100 no-bottom-space compact-input">
                    <mat-label>Comissão (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                      formControlName="percentualComissao" placeholder="0" />
                    @if (discountsArray.controls[i].get('percentualComissao')?.hasError('min')) {
                    <mat-error> Não pode ser menor que zero </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-2 col-lg-2 delete-col">
                  <button type="button" mat-icon-button (click)="removeDescontoRow(i)" matTooltip="Remover">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            }

            @if (discountsArray.touched && discountsArray.hasError('minArrayLength')) {
            <mat-error class="comissao-erro" tabindex="-1">Cadastre ao menos uma faixa de comissão</mat-error>
            }
            @if (discountsArray.length === 0) {
            <app-empty-state icon="percent" title="Nenhum desconto configurado"
              subtitle="Adicione faixas de desconto para definir o percentual de comissão conforme o desconto aplicado.">
            </app-empty-state>
            }
          </div>
          }
        </div>
      </div>

      <!-- Seção 4: Dados Fiscais -->
      <div class="section-container" id="fiscal">
        <div class="section-title">
          <mat-icon>receipt_long</mat-icon>
          <span>Dados Fiscais</span>
        </div>

        <div class="row">
          <div class="col-4">
            <app-select-pesquisavel [control]="idIndicadorInscricaoEstadual" [offlineList]="listaIndicadorInscricaoEstadual"
              label="Contribuinte" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Estadual</mat-label>
              <input matInput formControlName="inscricaoEstadual" />
            </mat-form-field>
          </div>

          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Municipal</mat-label>
              <input matInput formControlName="inscricaoMunicipal" />
            </mat-form-field>
          </div>

          <div class="col-4">
            <app-select-pesquisavel [control]="idRegimeTributario" [offlineList]="listaRegimeTributario"
              label="Regime Tributário" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-4">
            <app-select-pesquisavel [control]="idTipoTributario" [offlineList]="listaTipoTributario"
              label="Tipo Tributário" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Suframa</mat-label>
              <input matInput formControlName="inscricaoSuframa" />
            </mat-form-field>
          </div>

          <div class="col-6">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isConsumidorFinal"
                color="primary">Consumidor Final</mat-slide-toggle>
              <span class="info-text">
                Marque esta opção caso este cliente seja o consumidor final nas operações comerciais
              </span>
            </div>
          </div>

          <div class="col-6">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isContribuinteIbsCbs"
                color="primary">Contribuinte de IBS/CBS</mat-slide-toggle>
              <span class="info-text">Marque caso seja contribuinte de impostos sobre bens e serviços</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 5: Dados Complementares -->
      <div class="section-container" id="complementar">
        <div class="section-title">
          <mat-icon>description</mat-icon>
          <span>Dados Complementares</span>
        </div>

        <div class="row">
          <div class="col-4">
            <app-select-pesquisavel [control]="idVendedorResponsavel" [offlineList]="opcoesVendedorResponsavel"
              label="Vendedor Responsável" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-12">
            <div class="equipe-titulo">
              <span>Equipe (subordinados diretos)</span>
            </div>
            <div class="equipe-apoio">
              Monte a equipe daqui em vez de abrir um cadastro por vez: quem entrar nesta lista passa
              a ter este vendedor como Vendedor Responsável ao salvar.
            </div>
            <app-vendedor-equipe-seletor [idVendedor]="idVendedor"
              [idVendedorResponsavelAtual]="idVendedorResponsavel.value" [flatHierarquia]="flatHierarquia"
              [membrosIniciais]="membrosIniciais" (equipeChange)="onEquipeChange($event)">
            </app-vendedor-equipe-seletor>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Observações Gerais</mat-label>
              <textarea matInput formControlName="observacoesGerais" rows="5"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Seção 6: Restrições de acesso -->
      <div class="section-container section-container-spaced" id="restricoes">
        <div class="section-title">
          <mat-icon>visibility</mat-icon>
          <span>Restrições de acesso</span>
        </div>

        @if (!restricoesDisponiveis) {
        <div class="restricoes-neutra">
          <mat-icon>lock</mat-icon>
          <span>
            Disponível apenas para "Ativo com acesso ao sistema" — o escopo de visualização só faz
            sentido para quem acessa o sistema. Altere a Situação em Informações Básicas para
            configurar as restrições deste vendedor.
          </span>
        </div>
        } @else {
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Escopo de visualização</mat-label>
              <mat-select formControlName="idEscopoVendedor">
                <mat-select-trigger>{{ rotuloEscopo }}</mat-select-trigger>
                @for (opcao of opcoesEscopo; track opcao.id) {
                <mat-option [value]="opcao.id">
                  <span class="escopo-opcao-rotulo">{{ opcao.rotulo }}</span>
                  <span class="escopo-opcao-descricao">{{ opcao.descricao }}</span>
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12">
            <div class="restricoes-apoio">
              Escopo de visualização deste vendedor, válido para o CRM, o Processo de vendas e, no futuro,
              Nota e Financeiro. Sem restrição configurada, ele vê todos os registros.
            </div>
          </div>

          @if (idEscopoVendedor.value === EscopoVisualizacaoEnum.Equipe) {
          <div class="col-12">
            <div class="restricoes-painel-equipe">
              <div class="restricoes-painel-titulo">Equipe calculada pela hierarquia</div>
              @if (idsEquipeAtual.length === 0) {
              <div class="restricoes-painel-texto">
                Este vendedor ainda não possui outros profissionais vinculados a ele como "Vendedor
                Responsável". Por isso, as opções "Ver apenas os próprios" e "Ver a equipe" exibirão
                os mesmos dados no momento. Assim que a equipe for configurada, a visualização se
                atualizará automaticamente.
              </div>
              } @else {
              <div class="restricoes-chips">
                @for (idMembro of idsEquipeAtual; track idMembro) {
                <span class="restricoes-chip">{{ getNomeVendedor(idMembro) }}</span>
                }
              </div>
              <div class="restricoes-painel-texto">
                Vendedores que apontam para este cadastro em <strong>Vendedor Responsável</strong>,
                direta ou indiretamente, em qualquer profundidade.
              </div>
              }
            </div>
          </div>
          }

          <div class="col-12">
            <app-alert-card type="info" title="Como funciona a visibilidade de dados:">
              <div class="restricoes-nota-item"><strong>Um escopo para todos os módulos:</strong> o mesmo
                escopo vale para o CRM, o Processo de vendas e os relatórios de Vendas, e é aplicado
                automaticamente. Nota e Financeiro passarão a usá-lo quando forem liberados.</div>
              <div class="restricoes-nota-item"><strong>Usuários sem Vendedor Vinculado:</strong>
                Administradores e equipe do Financeiro têm visualização completa de todos os dados por
                padrão.</div>
              <div class="restricoes-nota-item"><strong>Documento sem vendedor responsável:</strong>
                documento salvo sem vendedor responsável fica visível para todos, independentemente do
                escopo — sem responsável, não há a quem restringir.</div>
              <div class="restricoes-nota-item"><strong>Cadastro de Pessoas:</strong> a restrição para
                vendedores continua na opção "Restringir acesso dos vendedores".</div>
            </app-alert-card>
          </div>
        </div>
        }
      </div>
    </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>